import React from 'react';
import NavSmallScreen from "./NavSmallScreen";
import NavLargeScreen from "./NavLargeScreen";
import {useIsScreenMobile, useIsScreenTablet} from "@florian-cassagne/simple-toolbox";
import NavItems from "../NavItems";

function Nav({children}) {

  const isScreenMobile = useIsScreenMobile()
  const isScreenTablet = useIsScreenTablet()


  return (
    (isScreenMobile || isScreenTablet) ?
      <NavSmallScreen>
        <NavItems isSmallScreen/>
      </NavSmallScreen>
      :
      <NavLargeScreen>
        <NavItems/>
      </NavLargeScreen>

  );
}


export default Nav;
